import { Box, Caption, Flex } from '@mediahuis/chameleon-react';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { StatusIcon } from './PhoneInfo';
import MailImg from './img/mail.svg';
var MailIcon = styled.div.withConfig({
  displayName: "EmailInfo__MailIcon",
  componentId: "sc-qtzmj9-0"
})(["margin-left:9px;background-image:url(", ");width:56px;height:56px;background-size:contain;background-repeat:no-repeat;background-position:center;"], MailImg);

var EmailInfo = function EmailInfo(_ref) {
  var componentData = _ref.componentData;
  var mainText = componentData.mainText,
      editText = componentData.editText;
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 4
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(MailIcon, null), /*#__PURE__*/React.createElement(StatusIcon, {
    output: "OPEN"
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Caption, {
    level: 2
  }, parse(mainText)), /*#__PURE__*/React.createElement(Caption, {
    level: 2
  }, parse(editText))));
};

export default EmailInfo;